export const RESET_PASSWORD_SUCCESS_CARD_TITLE =
  'Your password was successfully reset!';

export const RESET_PASSWORD_SUCCESS_BUTTON_TEXT = 'Log in Now';
